import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import NoVideoView from './NoVideoView';
import VideoView from './VideoView';
import { useCall, useSelfViewContext, useTwilioUserMediaContext } from '../../customer-call-sdk';
import VideoStoppedView from './VideoStoppedView';
import SelfViewControl from './SelViewControl';

const StyledSelfView = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`;
/**
 * Self view container component
 */
const SelfView: React.FC = () => {
    const {
        isMediaPermissionInitialized,
        isMediaPermissionGranted,
        isMediaPermissionDenied,
        isMediaStopped,
        isRequestingMediaPermission,
    } = useTwilioUserMediaContext();

    const { turnOn, turnedOff } = useSelfViewContext();
    const { connected, isConnecting } = useCall();
    const [initialized, setInitialized] = useState(false);

    const renderView = () => {
        if (isMediaPermissionDenied || isRequestingMediaPermission) {
            return <NoVideoView data-testid="no-video-view" />;
        }

        if (isMediaStopped) {
            return <VideoStoppedView />;
        }

        if (isMediaPermissionGranted) {
            return <VideoView />;
        }
        return null;
    };

    // turn on self view if media is initialized and permission is granted
    useEffect(() => {
        if (
            isMediaPermissionInitialized &&
            isMediaPermissionGranted &&
            !turnedOff &&
            !initialized
        ) {
            if (isMediaStopped) {
                turnOn();
            }
            setInitialized(true);
        }
    }, [
        initialized,
        isMediaPermissionInitialized,
        isMediaPermissionGranted,
        turnOn,
        isMediaStopped,
    ]);

    return (
        <StyledSelfView>
            {renderView()}
            {isMediaPermissionGranted && !(isConnecting || connected) && <SelfViewControl />}
        </StyledSelfView>
    );
};

export default SelfView;
